import {ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, catchError, EMPTY, Subject} from "rxjs";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {AssociationsService} from "@shared/services/associations.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ValidateIfObject} from "@shared/validators/if-object.validator";
import {map, take} from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import {SharedService} from "@shared/shared.service";
import {OrganizationManagerModel} from "@services/back-office/model/organizationManagerModel";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BillingCounterpartyModel} from '@services/back-office';

@Component({
    selector: 'app-counterparty-manager-dialog',
    templateUrl: './counterparty-manager-dialog.component.html',
    styleUrls: ['./counterparty-manager-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CounterpartyManagerDialogComponent implements OnInit, OnDestroy {
    /** Loading */
    loading$ = new BehaviorSubject(false);
    /** Form */
    managerForm: UntypedFormGroup;
    /** Subject to destroy Subscriptions */
    private destroyed$ = new Subject<void>();

    roles: string[] = [
        'SALES_MANAGER',
        'SUPPORT_MANAGER',
        'SUPPORT_ACCOUNTING_MANAGER',
        'ACCOUNTING_MANAGER'
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            counterparty: BillingCounterpartyModel,
            notAllowedTypes: string[];
        },
        public dialogRef: MatDialogRef<CounterpartyManagerDialogComponent>,
        private associationsService: AssociationsService,
        private formBuilder: UntypedFormBuilder,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {
    }

    ngOnInit(): void {
        this.initForm();
        if (this.data.notAllowedTypes?.length) {
            for (let i = 0; i < this.data.notAllowedTypes.length; i++) {
                this.roles = this.roles.filter(el => el != this.data.notAllowedTypes[i]);
            }
        }
    }

    initForm() {
        this.managerForm = this.formBuilder.group({
            manager: ['', [Validators.required, ValidateIfObject]],
            position: ['', [Validators.required]],
        });
    }

    ngOnDestroy() {
        this.destroyed$.complete();
        this.loading$.complete();
    }

    submitForm() {
        const formData = this.managerForm.getRawValue();
        this.loading$.next(true);

        this.associationsService.addOrganizationManager({
            organization: {id: this.data.counterparty.id},
            manager: formData.manager,
            position: formData.position
        }).pipe(
            take(1),
            map((response: OrganizationManagerModel) => {
                this.loading$.next(false);
                this.closeDialog(true, response);
            }),
            catchError((error: HttpErrorResponse) => {
                SharedService.showErrorWithTitle(
                    this.translateService,
                    this.toastrService,
                    `responseErrors.${error.error.message}`
                );
                this.loading$.next(false);
                return EMPTY;
            })
        ).subscribe();

    }

    /** Close dialog */
    closeDialog(result: boolean, data?: any) {
        this.dialogRef.close({result, data});
    }
}
